const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];

/**
 * Photo affichable par le navigateur (selon le type MIME ou, à défaut, l'extension)
 */
export function isDocumentImage(document) {
    if (!document || document.is_folder) {
        return false;
    }

    if (document.mime && String(document.mime).indexOf('image/') === 0) {
        return ['image/heic', 'image/heif', 'image/tiff'].indexOf(String(document.mime)) === -1;
    }

    return IMAGE_EXTENSIONS.indexOf(String(document.extension || '').toLowerCase()) !== -1;
}
